// Native
import { useEffect, useState } from "react"
import { useParams } from "react-router"

// Style
import { Button, ButtonGroup, Divider, HStack, ModalBody, ModalFooter, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Form, Modal } from "components"

// Config & Hooks
import { API } from "config"
import { useDistributor, useDistributorStock } from "hooks"

// Screens
import { ModalPassword } from "screens"

export default function Change({ data, ...props }){

    const params = useParams()
    const toast = useToast()
    const distributor = useDistributor(params?.id)
    const stock = useDistributorStock(params?.id)
    const auth = useDisclosure()
    const [ form, setForm ] = useState(data)
    const [ loading, setLoading ] = useState(false)
    const [ errors, setErrors ] = useState()

    const onChange = ({ target }) => {
        const { name, value } = target
        setForm({...form, [name]: value })
    }

    const handleSubmit = async () => {
        setLoading(true)
        setErrors(false)

        try{
            await API.put(`/distributors/${distributor.data.id}/stock/${data.id}`, form)
            props.onClose()
            stock.refetch()
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível ajustar o estoque', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    useEffect(() => {
        setForm(data)
    }, [data])

    return(
    <>
    <Modal title={`Estoque de: ${data?.product?.name ?? data?.product_kit?.label}`} loading={loading} {...props}>
        <ModalBody>
            <Alert status="warning" children={`Você está prestes a alterar o estoque do produto ${data?.product?.name ?? data?.product_kit?.label} para o núcleo ${distributor?.data?.name}.`} />
            <Divider my={4} />

            <Form.Form onSubmit={auth.onOpen}>
                <HStack>
                    
                    <Form.Text 
                        label="Estoque:"
                        type="number"
                        name="stock"
                        value={form?.stock}
                        error={errors?.stock}
                        onChange={onChange}
                        isDisabled={loading}
                        fontWeight="bold"
                        size="lg"
                    />

                    <Form.Text 
                        label="Reservado:"
                        type="number"
                        name="reserved"
                        value={form?.reserved}
                        error={errors?.reserved ?? (form?.reserved > form?.stock) ? 'Não pode ser maior' : null}
                        max={form?.stock}
                        onChange={onChange}
                        isDisabled={loading}
                        fontWeight="bold"
                        size="lg"
                    />

                    <Form.Text 
                        label="Disponível:"
                        type="number"
                        value={form?.stock - form?.reserved}
                        isDisabled
                        fontWeight="bold"
                        size="lg"
                    />

                </HStack>

                <Form.Textarea
                    label="Motivo da alteração:"
                    name="label"
                    value={form?.label}
                    error={errors?.label}
                    onChange={onChange}
                    isDisabled={loading}
                    placeholder="Ex.: Solicitado pelo cliente e autorizado pelo departamento responsável."
                    helper="É importante adicionar aqui o motivo específico por estar realizando esta alteração no estoque para validação futura."
                    size="sm"
                />
                
            </Form.Form>
        </ModalBody>

        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button children="Alterar estoque" colorScheme="orange" onClick={auth.onOpen} isLoading={loading} />
                <Button children="Cancelar" colorScheme="red" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>

    </Modal>

    {/* Auth */}
    <ModalPassword {...auth} onSuccess={handleSubmit} />
    </>
    )
}